module.exports = __webpack_public_path__ + "media/12.9c0ba659.mp3";